<template>
  <div>
    <el-tooltip
      v-if="!isDefault"
      class="item"
      effect="dark"
      placement="top-start"
      content="Edit"
    >
      <router-link :to="`/notifications/${automation.id}`" title="Edit">
        <el-button
          type="success"
          plain
          circle
          size="small"
          icon="EditElementIcon"
          class="small-action-btn"
        />
      </router-link>
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      placement="top-start"
      content="Delete"
    >
      <span>
        <el-popconfirm
          confirm-button-text="OK"
          cancel-button-text="No, Thanks"
          confirm-button-type="danger"
          icon="InfoFilledElementIcon"
          icon-color="red"
          :title="`Are you sure to delete '${automation.name}' notification?`"
          @confirm="handleConfirm"
        >
          <template #reference>
            <el-button
              type="danger"
              plain
              circle
              size="small"
              icon="DeleteElementIcon"
              class="small-action-btn"
            />
          </template>
        </el-popconfirm>
      </span>
    </el-tooltip>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { useAutomationsStore } from '@/store/modules/automations'

export default defineComponent({
  name: 'AutomationActions',
  props: {
    automation: {
      type: Object,
      required: true
    }
  },
  setup(props, context) {
    const automationsStore = useAutomationsStore()
    const isDefault = computed(() => props.automation.is_default)

    const handleConfirm = () => {
      const automationId = props.automation.id.toString()

      const request = isDefault.value
        ? automationsStore.DisableDefaultAutomation(automationId)
        : automationsStore.DeleteAutomation(automationId)

      request.then(() => {
        ElMessage.success({
          message: 'Notification has been deleted',
          type: 'success'
        })
      })
    }

    return {
      handleConfirm,
      isDefault
    }
  }
})
</script>

<style lang="scss" scoped>
.small-action-btn {
  margin-right: 3px;
}
</style>
